import { supabase } from '../supabaseClient';

export async function draftDocument(caseId, templateKey, extraInstructions) {
  const { data, error } = await supabase.functions.invoke('draft-document', {
    body: { caseId, templateKey, extraInstructions },
  });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data.draft;
}